// Selector timing events (PostHog). Fired identically on classic and Beta so
// the A/B comparison is apples-to-apples — see the handoff README's event table.
// product: 'ifp' | 'imp' · variant: 'beta' | 'classic'
import posthog from 'posthog-js'; // singleton — same instance main.js initialized

const viewedAt = {};

function capture(event, props) {
  try {
    posthog.capture(event, props);
  } catch (e) {
    /* analytics must never break the page */
  }
}

export function trackSelectorViewed(product, variant) {
  viewedAt[product] = Date.now();
  capture('selector.viewed', { product, variant });
}

function msSinceView(product) {
  return viewedAt[product] ? Date.now() - viewedAt[product] : null;
}

// method: 'keyword' | 'naics_code' | 'browse' | 'favorite'
export function trackIndustrySelected(product, variant, method) {
  capture('selector.industry_selected', { product, variant, method, ms_since_view: msSinceView(product) });
}

// step: 'market_area' | 'sales_class' | 'defaults'
export function trackStepCompleted(product, variant, step) {
  capture('selector.step_completed', { product, variant, step, ms_since_view: msSinceView(product) });
}

export function trackSelectorCompleted(product, variant) {
  capture('selector.completed', { product, variant, total_ms: msSinceView(product) });
}

const upsellShownAt = {};

// direction: 'imp_to_ifp' | 'ifp_to_imp'
export function trackUpsellShown(direction, placement) {
  upsellShownAt[direction] = Date.now();
  capture('upsell.shown', { direction, placement });
}

export function trackUpsellAccepted(direction, salesClass) {
  capture('upsell.accepted', {
    direction,
    sales_class: salesClass || null,
    ms_since_shown: upsellShownAt[direction] ? Date.now() - upsellShownAt[direction] : null,
  });
}

export function trackUpsellDismissed(direction) {
  capture('upsell.dismissed', {
    direction,
    ms_since_shown: upsellShownAt[direction] ? Date.now() - upsellShownAt[direction] : null,
  });
}

/* ==================== v4/v5 additions ==================== */

export function trackCompanySearched(qLen, stateScope, nResults) {
  capture('company.searched', { q_len: qLen, state_scope: stateScope, n_results: nResults });
}

// method: 'search' | 'favorite'
export function trackCompanySelected(method) {
  capture('company.selected', { method, ms_since_view: msSinceView('company_profile') });
}

export function trackProspectFilterApplied(filter, value, resultingCount) {
  capture('prospect.filter_applied', { filter, value: String(value), resulting_count: resultingCount });
}

export function trackProspectResultsUpdated(count, nActiveFilters) {
  capture('prospect.results_updated', { count, n_active_filters: nActiveFilters, ms_since_view: msSinceView('prospect_list') });
}

export function trackProspectNarrowWarning(count, lastFilter) {
  capture('prospect.narrow_warning', { count, last_filter: lastFilter });
}

// method: 'existing' | 'created_inline'
export function trackReportInputsSelected(product, method, ageDays) {
  capture('report.inputs_selected', { product, method, age_days: ageDays });
}

export function trackReportInputsCreated(product, fieldsFilled) {
  capture('report.inputs_created', { product, fields_filled: fieldsFilled, ms_since_view: msSinceView(product) });
}
